import { useTranslation } from 'react-i18next';
import { createFileRoute } from '@tanstack/react-router';

import { Box, Typography } from '@mui/material';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/clients')({
  component: ClientsPage,
});

function ClientsPage() {
  const { t } = useTranslation('common');

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4">{t('clients.title', 'Clients')}</Typography>
      <Typography variant="body1" color="text.secondary">
        {t('clients.subtitle', 'Manage your clients here.')}
      </Typography>
    </Box>
  );
}
